import { AppRoutes } from '@/utils';

export const BannerSlotKeys = {
  Navigation: 'ces-pb-navigation',
  Title: 'ces-pb-title',
  TitleAction: 'ces-pb-title-action',
  TitleMeta: 'ces-pb-title-meta',
  TitleMetaPinned: 'ces-pb-title-meta-pinned',
  Note: 'ces-pb-note',
} as const;

export const TITLE_MEASURE_ATTRIBUTE = 'data-banner-title-measure';

export type BannerAppearance = {
  isSticky?: boolean;
  hidden?: boolean;
  variant?: 'default' | 'expanded';
  dynamicHeight?: boolean;
  isTall?: boolean;
  syncCollapse?: boolean;
};

export const bannerAppearanceMap: Partial<Record<AppRoutes, BannerAppearance>> = {
  [AppRoutes.HCP_OVERVIEW]: {
    isSticky: true,
    variant: 'expanded',
    isTall: true,
    syncCollapse: true,
  },
  [AppRoutes.HCO_OVERVIEW]: {
    isSticky: true,
    variant: 'expanded',
    isTall: true,
    syncCollapse: true,
  },
  [AppRoutes.HCP_CONFERENCE_ABSTRACT_DETAILS]: {
    isSticky: true,
  },
  [AppRoutes.CONFERENCE_ONE_PAGER]: {
    isSticky: true,
    variant: 'expanded',
    dynamicHeight: true,
  },
  [AppRoutes.HCP_CLINICAL_TRIAL_DETAILS]: {
    isSticky: true,
    variant: 'expanded',
  },
  [AppRoutes.CUSTOMER_FOCUS]: {
    hidden: true,
  },
  [AppRoutes.AGGREGATED_SCIENTIFIC_INFORMATION_OVERVIEW]: {
    variant: 'expanded',
  },
  [AppRoutes.AGGREGATED_SCIENTIFIC_INFORMATION_CLINICAL_TRIALS]: {
    variant: 'expanded',
  },
  [AppRoutes.AGGREGATED_SCIENTIFIC_INFORMATION_PUBLICATIONS]: {
    variant: 'expanded',
  },
  [AppRoutes.AGGREGATED_SCIENTIFIC_INFORMATION_CONGRESS_ACTIVITY]: {
    variant: 'expanded',
  },
};
